export default "__VITE_ASSET__6HLsAd8a__"